import { isPossiblePhoneNumber } from "react-phone-number-input";

/**
 * Whether the user has a phone number that allows mobile login (SMS or login code).
 * Aligns with backend loginWithCode check + panel InputPhoneNumber validation.
 */
export function isValidPhoneForMobileLogin(phoneNumber, countryCode = "TR") {
  const raw = (phoneNumber || "").trim();
  if (!raw || raw === "-") {
    return false;
  }

  const cc = (countryCode || "TR").toUpperCase();
  let e164;
  if (cc === "TR") {
    e164 = raw.startsWith("+") ? raw : `+90${raw}`;
  } else {
    e164 = raw.startsWith("+") ? raw : `+${raw}`;
  }

  return isPossiblePhoneNumber(e164);
}
